import { render, staticRenderFns } from "./agreementAdd.vue?vue&type=template&id=454ae96f"
import script from "./agreementAdd.vue?vue&type=script&lang=js"
export * from "./agreementAdd.vue?vue&type=script&lang=js"
import style0 from "./agreementAdd.vue?vue&type=style&index=0&id=454ae96f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports